module.exports = __webpack_public_path__ + "img/stop.c8fe59cc.png";